// extracted by mini-css-extract-plugin
module.exports = {"home-battery":"HomeBattery_home-battery__YwjeR"};